import React from 'react';
import VisualSalesScoreboard from './VisualSalesScoreboard';

export default function VisualSalesScoreboardPage({ user, managedOwner }) {
  return <VisualSalesScoreboard user={user} managedOwner={managedOwner} />;
}
